import React from 'react';
import clsx from 'clsx';
import styles from './notification-dot.module.scss';

interface Props {
  className?: string
}

export const NotificationDot: React.FC<Props> = ({ className }) => {
  return (
    <span
      className={clsx(
        styles['notification-dot'],
        className
      )}
      aria-hidden="true"
    />
  );
};

export default NotificationDot;
